var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DictTable',{attrs:{"pid":_vm.dictId,"module-name":"港口","dictType":"harbour"}})
}
var staticRenderFns = []

export { render, staticRenderFns }